// Language Translations
export const translations = {
    en: {
        daily: 'Daily',
        totalExpense: 'Total Expense',
        accountUpdated: 'Account Updated!',
        accountAdded: 'Account Added!',
        day: 'Date',
        transactionUpdated: 'Transaction Updated!',
        accountDeleted: 'Account Deleted!',
        transactionRemoved: 'Transaction Removed!',
        // Common & Navigation
        home: 'Home',
        back: 'Back',
        profile: 'Profile',
        settings: 'Settings',
        logout: 'Log Out',
        menu: 'Menu',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        delete: 'Delete',
        confirmDelete: 'Confirm Delete',
        deleteAccount: 'Delete Account',
        areYouSure: 'Are you sure you want to delete?',
        beforeYouDelete: 'Before you delete this account:',
        accountNoLongerAppear: 'This account will no longer appear in your account list.',
        pastTransactionsUnchanged: 'Past transactions will remain unchanged.',
        accountBalanceMustBeZero: 'Account balance must be 0 before deletion.',
        edit: 'Edit',
        submit: 'Submit',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        warning: 'Warning',
        info: 'Info',

        // Auth Messages
        userNotAuthorized: 'User is not authorized',
        somethingWentWrong: 'Something went wrong! Please try again later.',
        invalidCredentials: 'Invalid email or password',
        loginFailed: 'Login failed. Please try again.',
        logoutSuccess: 'Logged out successfully',
        registerSuccess: 'Registration successful! Please log in.',
        loginSuccess: 'Login successful!',

        // Profile Page
        myAccount: 'My Account',
        updatePassword: 'Update Password',
        helpCenter: 'Help Center',
        helpCenterSubtitle: 'Quick answers to the most common questions about Xpenso',
        searchFaqPlaceholder: 'Search for a topic...',
        noFaqFound: 'No matching results',
        noFaqFoundHint: 'Try a different keyword or browse all questions below',
        clearSearch: 'Clear',
        faqCount: 'questions',
        changePassword: 'Change Password',
        forgotPassword: 'Forgot Password?',
        resetPassword: 'Reset Password',
        passwordUpdated: 'Password updated successfully',
        passwordUpdateFailed: 'Failed to update password',
        passwordUpdateSubtitle: 'Keep your account secure with a strong, unique password',
        passwordRequirementHint:
            'Use at least 6 characters. Mix uppercase, numbers & symbols for a strong password.',

        // Authentication
        email: 'Email Address',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        currentPassword: 'Current Password',
        enterEmail: 'Enter your email address',
        enterPassword: 'Enter your password',
        enterNewPassword: 'Enter your new password',
        emailId: 'Email id',
        rememberMe: 'Remember Me',
        forgotPin: 'Forgot Password?',
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign In',
        signUp: 'Create Free Account',
        signUpSubTitle: 'Start tracking your money today.',
        enterName: 'Enter your name',
        signupWithEmail: 'Create Account with Email',
        continueWithGoogle: 'Continue with Google',
        continueWithFacebook: 'Continue with Facebook',
        createAccount: 'Create Account',
        passwordsDoNotMatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        invalidEmail: 'Please enter a valid email',
        register: 'Register',
        login: 'Login',
        or: 'OR',

        // Home Page
        totalBalance: 'Total Balance',
        totalIncome: 'Total Income',
        total: 'Total',
        income: 'Income',
        expense: 'Expense',
        recentTransactions: 'Recent Transactions',
        topExpenses: 'Top Expenses',
        allWallets: 'All Wallets',
        wallets: 'Wallets',
        noTransactions: 'No transactions yet',
        noAccounts: 'No accounts yet',
        noCards: 'No cards yet',
        noCardAdded: 'No cards.',
        youHaventAdded: "You haven't added any cards yet !!",
        viewAll: 'View All',
        addNew: 'Add New',
        addAccount: 'Add Account',
        addCard: 'Add Card',
        statistics: 'Statistics',
        expensePerDay: 'Expense Per Day',
        todayExpense: 'Expense Today',
        monthlyAnalytics: 'Monthly Analytics',
        balanceTrend: 'Balance Trend',
        categoryWiseExpense: 'Category Wise Expense',
        categoryWiseIncome: 'Category Wise Income',
        analytics: 'Analytics',
        expenses: 'Expenses',
        notification: 'Notification',
        muteNotification: 'Mute notification',
        markAsAllRead: 'Mark as all read',
        removeAll: 'Remove all',
        system: 'System',
        noNewNotification: 'No New Notification',
        noNotificationFound: 'No notification found in last 30 days !!',
        addMoney: '+ Add Money',
        transactionSuccessful: 'Transaction Successful!',
        thisMonth: 'This Month',
        seeAll: 'See all',
        noExpenses: 'No Expenses.',
        noExpenseThisMonth: 'No expense found this month !!',
        noExpenseThisYear: 'No expense found this year !!',
        latestTransaction: 'Latest Transaction',
        mostRecent: 'Most Recent',
        balance: 'Balance',
        accounts: 'Accounts',
        account: 'Account',
        currentBalance: 'Current Balance',
        showInHome: 'Show In Home',
        showInHomeInfo:
            'When enabled, this account will appear on your home screen for quick access.',
        countTowardsTotal: 'Include in Home Balance',
        countTowardsTotalInfo:
            "Turn this off for investments like FDs or SIPs. If turned off, this balance won't be included in your homepage total.",
        updateAccount: 'Update Account',
        enterAccountName: 'Enter account name',
        enterCurrentBalance: 'Enter current balance',
        enterAccountNumber: 'Enter account number',
        accountRemarks: 'Remarks',
        enterAccountRemarks: 'Add a note about this account...',
        accountAttachment: 'Account Attachment',
        transactionAttachment: 'Attachment',
        uploadAttachment: 'Upload File',
        changeAttachment: 'Change File',
        viewAttachment: 'View',
        imageUnavailable: 'Image unavailable',
        confirmAttachmentDelete: 'Delete this attachment? This action cannot be undone.',
        deleteAttachment: 'Delete attachment',
        attachmentUploaded: 'Attachment uploaded!',
        attachmentDeleted: 'Attachment removed!',
        uploadingAttachment: 'Uploading attachment...',
        onlyImageAllowed: 'Only image files (JPEG, PNG, WebP) are allowed.',
        onlyAttachmentTypesAllowed: 'Only JPEG, PNG, WebP, PDF or TXT files are allowed.',
        fileSizeLessThan4MB: 'File size must be less than 4 MB.',

        currentAccount: 'Current Account',
        savingsAccount: 'Savings Account',
        fixedDeposit: 'Fixed Deposit',
        depositPremiumScheme: 'Deposit Premium Scheme (DPS)',
        cards: 'Cards',
        loadingCards: 'Loading cards',
        cardsSlider: 'Cards slider',
        cardsAvailable: 'cards available',
        logOut: 'Log out',
        dark: 'Dark',

        // Transaction
        transactions: 'Transactions',
        transactionHistory: 'Transaction History',
        transaction: 'Transaction',
        amount: 'Amount',
        date: 'Date',
        category: 'Category',
        description: 'Description',
        from: 'From',
        to: 'To',
        status: 'Status',
        pending: 'Pending',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled',
        time: 'Time',
        noData: 'No data available',

        // Categories
        categoryExpense: 'Category Expense',
        allCategories: 'All Categories',
        food: 'Food',
        transport: 'Transport',
        shopping: 'Shopping',
        entertainment: 'Entertainment',
        utilities: 'Utilities',
        healthcare: 'Healthcare',
        education: 'Education',
        other: 'Other',

        // Reports
        reports: 'Reports',
        balanceReport: 'Balance Report',
        incomeReport: 'Income Report',
        cashFlow: 'Cash Flow',
        monthly: 'Monthly',
        yearly: 'Yearly',
        reportType: 'Report Type',
        lastMonth: 'Last Month',
        thisYear: 'This Year',
        lastYear: 'Last Year',
        lending: 'Lending',
        monthlyStatistics: 'Monthly Statistics',
        yearlyStatistics: 'Yearly Statistics',
        earnings: 'Net earnings',
        dropped: 'dropped by',
        improved: 'improved by',
        comparedToPreviousMonth: 'compared to the previous month',
        comparedToLastYear: 'compared to last year',
        theSameAsLastYear: "last year's",

        // Settings
        systemLanguage: 'System Language',
        chooseLanguage: 'Choose your preferred language',
        darkMode: 'Dark Mode',
        notifications: 'Notifications',
        privacyPolicy: 'Privacy Policy',
        termsConditions: 'Terms & Conditions',
        about: 'About',
        version: 'Version',
        accountSettings: 'Account Settings',
        securitySettings: 'Security Settings',
        appSettings: 'App Settings',
        pushNotifications: 'Push Notifications',
        getNotified: 'Stay notified about important updates and alerts',
        languageRegion: 'Language & Region',
        securityPrivacy: 'Security & Privacy',
        updatePasswordRegularly: 'Change Password regularly',
        twoFactorAuth: 'Two-Factor Authentication (2FA)',
        extraSecurityLayer: 'Extra Layer of Security / Secure your account',
        helpSupport: 'Help & Support',
        findAnswers: 'Help Center / FAQ / Get Help',
        soon: 'Coming Soon',
        installApp: 'Install App',
        install: 'Install',
        viewInstructions: 'How to install',
        installAppDescIOS: 'iPhone/iPad: Use Safari → Share → Add to Home Screen.',
        installAppDescAndroid: 'Android: Install the app for a faster, full-screen experience.',
        installAppDescDesktop: 'Desktop: Install the app for quick access from your computer.',
        installAppDescSafariDesktop:
            'Safari (Mac): Use File → Add to Dock, or Share → Add to Home Screen (if available).',
        installAppNotAvailableDesktop:
            "Install isn't available right now. In Chrome/Edge, use the Install icon in the address bar or go to Menu → Install app.",
        installAppNotAvailableAndroid:
            "Install prompt isn't available right now. Open Chrome menu (⋮) and tap 'Install app' or 'Add to Home screen'.",

        // Account
        accountName: 'Account Name',
        accountNumber: 'Account Number',
        accountType: 'Account Type',
        createdDate: 'Created Date',
        lastUpdated: 'Last Updated',
        myAccounts: 'My Accounts',
        accountDetails: 'Account Details',
        accountBalances: 'Account Balances',

        // Cards
        cardNumber: 'Card Number',
        lastFourDigits: 'Last 4 Digits',
        cardholderName: 'Cardholder Name',
        bankName: 'Bank Name',
        expiryDate: 'Exp. Date',
        cvv: 'CVV',
        cardType: 'Card Type',
        myCards: 'My Cards',
        addNewCard: 'Add New Card',
        cardAdded: 'Card added successfully',
        cardRemoved: 'Card removed successfully',
        cardUpdateSuccessful: 'Card Update Successful!',
        updateCard: 'Update Card',
        creditCard: 'Credit Card',
        debitCard: 'Debit Card',
        cardNetwork: 'Card Network',
        americanExpress: 'American Express',
        visa: 'VISA',
        mastercard: 'MASTER',
        expiry: 'Expiry',
        enterLast4Digits: 'Enter last 4 digits',

        // Forms
        name: 'Name',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone Number',
        mobileNumber: 'Mobile Number',
        address: 'Address',
        city: 'City',
        state: 'State',
        country: 'Country',
        zipCode: 'Zip Code',
        dateOfBirth: 'Date of Birth',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        required: 'This field is required',
        pleaseEnter: 'Please enter',
        selectOption: 'Select an option',

        // Actions
        update: 'Update',
        create: 'Create',
        remove: 'Remove',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        sort: 'Sort',
        refresh: 'Refresh',
        download: 'Download',
        export: 'Export',
        import: 'Import',
        upload: 'Upload',
        confirm: 'Confirm',
        verify: 'Verify',
        send: 'Send',
        skip: 'Skip',
        next: 'Next',
        previous: 'Previous',
        apply: 'Apply',
        selectBothDates: 'Please select both dates.',
        startDateBeforeEndDate: 'Start date must be before end date.',

        // Notifications
        noNotifications: 'No notifications',
        newNotification: 'New notification',
        markAsRead: 'Mark as read',
        clearAll: 'Clear all',

        // Help & Support
        needHelp: 'Need Help?',
        contactSupport: 'Contact Support',
        faq: 'FAQ',
        documentation: 'Documentation',
        reportIssue: 'Report an Issue',
        feedbackAndSuggestions: 'Feedback & Suggestions',

        // PWA Installation
        installXpensoToHomeScreen: 'Install Xpenso to your Home for best experience',
        clickShareIcon: 'Click The Share Icon',
        addToHomeScreen: 'Add to Home Screen',
        installInHome: 'Install in Home',

        // Validation Messages
        validationError: 'Validation error',
        invalidInput: 'Invalid input',
        tryAgain: 'Please try again',
        checkNetwork: 'Please check your internet connection',
        serverError: 'Server error. Please try again later.',

        // Success Messages
        savedSuccessfully: 'Saved successfully',
        deletedSuccessfully: 'Deleted successfully',
        updatedSuccessfully: 'Updated successfully',
        createdSuccessfully: 'Created successfully',
        operationSuccessful: 'Operation successful',

        // Time
        today: 'Today',
        yesterday: 'Yesterday',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',

        // Login
        loginWelcome: 'Welcome back to Xpenso!',
        loginSubtitle: 'Easily track your money by logging in',

        forgetPassword: 'Forgot Password?',
        forgetPasswordSubtitle: "Don't worry! We've got your back.",
        resetPasswordEmail: 'Enter your registered email to reset your password.',
        otpVerification: 'Enter the OTP code sent to your email.',
        sendOTP: 'Send OTP',
        submitOTP: 'Submit OTP',
        emailNotFound: 'Email not found',
        tryAgainLater: 'Please try again later',
        // Account Types
        general: 'General',
        cash: 'Cash',
        current_account: 'Current Account',
        credit_card: 'Credit Card',
        savings_account: 'Savings Account',
        fixed_deposit: 'Fixed Deposit',
        dps: 'DPS',
        loan: 'Loan',
        investment: 'Investment',
        others: 'Others',
        enterOTP: 'Enter OTP',

        // New User Settings Page
        newUserSettings: 'New User Settings',
        setupAppPreferences: 'Configure your app preferences to get started.',
        selectCurrency: 'Select Currency',
        languageHint: 'All texts and numbers in the app will appear in this language.',
        currencyHint: 'This will be used as the default currency for all your transactions.',
        currentCashBalance: 'Current Cash Balance',
        cashBalanceHint: 'How much cash do you currently have in your physical wallet?',
        enterCurrentCash: 'Enter current cash',
        noServerResponse: 'No Server Response',
        invalidInputData: 'Invalid Input Data',
        userNotFound: 'User not found',
        settingsUpdatedSuccessfully: 'Settings updated successfully',

        // Add Transaction Modal
        transferMoney: 'Transfer Money',
        transfer: 'Transfer',
        addExpense: 'Add Expense',
        addIncome: 'Add Income',
        withdrawMoney: 'Withdraw Money',
        updateExpense: 'Update Expense',
        updateIncome: 'Update Income',
        withdraw: 'Withdraw',
        addExpenseShort: 'Add Expense',
        addIncomeShort: 'Add Income',
        fromAccount: 'From Account',
        toAccount: 'To Account',
        dateTime: 'Date & Time',
        remarks: 'Remarks',
        noteOrRemarks: 'Note or remarks',
        payee: 'Payee',
        payeeName: 'Payee name',
        borrowedFrom: 'Borrowed From',
        borrowedFromName: 'Name',
        selectAccount: 'Select an account',
        selectCategory: 'Select a category',
        outOfWallet: 'Out Of Wallet',
        addTransaction: 'Add Transaction',
        autoConfirm: 'Auto Confirm in',
        enterAmount: 'Enter amount',
        deleteTransactionConfirm: 'Are you sure you want to delete this transaction?',
        deleteCardConfirm: 'Are you sure you want to delete this card?',
        amountCannotBeEmpty: 'Amount can not be empty or 0.',
        selectToAccount: "Please select a 'To Account'.",
        accountsCannotBeSame: "'From Account' & 'To Account' can not be same",
        chooseDateAndTime: 'Please choose a date and time.',

        // TransactionHistory Page - NEW KEYS ONLY
        selectPeriod: 'Select Period',
        fromDate: 'From date',
        toDate: 'To date',
        noTransaction: 'No Transaction',
        noTransactionsFound: 'No transactions found !!',
        searchHere: 'Search Here',
        lastSixMonth: 'Last 6 Month',
        custom: 'Custom',
        resetFilters: 'Reset Filters',
        allTypes: 'All Types',
        noMoreTransactions: 'No more transactions',

        // MyAccount Page
        currency: 'Currency',
        taka: 'Taka (BDT/৳)',
        dollar: 'Dollar (USD/$)',
        onlyJPGPNGWebp: 'Only JPG, PNG, and WEBP files are allowed.',
        fileSizeShouldBeLess2MB: 'File size should be less than 2MB.',
        imageTooSmall: 'Image is too small. Minimum size is 100x100px.',
        invalidImageFile: 'Invalid image file.',
        userInfoUpdated: 'User info updated!',

        // PasswordUpdate Page
        oldPasswordRequired: 'Old password is required',
        newPasswordRequired: 'New password is required',
        confirmPasswordRequired: 'Please confirm your password',
        newPasswordMustBeDifferent: 'New password must be different from old password',
        passwordsMatch: 'Passwords match',
        showPassword: 'Show password',
        hidePassword: 'Hide password',
        updating: 'Updating...',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
        invalidOldPassword: 'Invalid old password',

        // HelpCenter Page
        whatIssuesAreFacing: 'What issues are you facing?',
        faq1Title: '1. What is Xpenso?',
        faq1Body:
            'Xpenso is your personal finance manager. It helps you track daily expenses, income, transfers, and monthly reports—all in one place.',
        faq2Title: '2. How do I add a new account?',
        faq2Body:
            'Tap "Add Account", enter the account name (e.g., Cash, Bank, bKash), set a balance, and save.',
        faq3Title: '3. How do I record an expense?',
        faq3Body: 'Tap Expense, select an account, add amount & category, and save.',
        faq4Title: '4. How do I add income?',
        faq4Body:
            'Tap Income, enter the details, and choose the account where you received the money.',
        faq5Title: '5. Can I transfer money between accounts?',
        faq5Body:
            'Yes! Use Transfer to move money from one account to another (e.g., Bank → bKash).',
        faq6Title: '6. What are Top Expenses?',
        faq6Body:
            "Top Expenses shows which categories (like Food, Groceries, etc.) you're spending the most on this month.",
        faq7Title: '7. What is Monthly Statistics?',
        faq7Body:
            'It compares your spending and income with the previous month, so you can see your progress.',
        faq8Title: '8. Is my data safe?',
        faq8Body:
            'Yes. Your data is stored securely in your account, and only you can access it. Xpenso never shares or uses your data for any other purpose.',
        faq9Title: '9. Can I edit or delete a transaction?',
        faq9Body: 'Yes! Open Latest Transactions, tap the one you want, and choose Edit or Delete.',
        remained: 'is same as ',
        theSameAsPreviousMonth: "previous month's ",

        // Voice Command
        voiceListening: 'Listening...',
        voiceProcessing: 'Processing...',
        voiceTapToSpeak: 'Say a command...',
        voiceStopListening: 'Stop listening',
        voiceMissingAmount: "Could not detect amount. Try: 'expense 200 food'",
        voiceMissingCategory: 'Could not match category',
        voiceMissingType: "Say 'expense' or 'income' before the amount",
        voiceNoAccount: 'No account found. Please add an account first.',
        voiceTryAgain: 'Could not understand. Please try again.',
        voiceNoSpeech: 'No speech detected. Tap and speak clearly.',
        voiceMicPermission: 'Microphone permission denied. Please allow access.',
        voiceNetworkError: 'Speech service blocked. Check browser privacy settings.',
        voiceNotSupported: 'Voice command is not supported in this browser.',
        voiceConfirmCategory: 'Which category did you mean?',
        voiceConfirmAccount: 'Which account?',

        viewTransaction: 'View Transaction',
        topCategory: 'Highest Expense Category',
        topCategoryExpenseAmount: 'Highest Category Expense',
    },
    bn: {
        daily: 'দৈনিক',
        totalExpense: 'মোট খরচ',
        accountUpdated: 'অ্যাকাউন্ট আপডেট করা হয়েছে!',
        accountAdded: 'অ্যাকাউন্ট যোগ করা হয়েছে!',
        day: 'তারিখ',
        transactionUpdated: 'লেনদেনটি আপডেট করা হয়েছে!',
        accountDeleted: 'অ্যাকাউন্ট মুছে ফেলা হয়েছে!',
        transactionRemoved: 'লেনদেনটি মুছে ফেলা হয়েছে!',
        remained: 'সমান',
        theSameAsPreviousMonth: 'রয়েছে',
        // Common & Navigation
        home: 'হোম',
        back: 'ফিরে যান',
        profile: 'প্রোফাইল',
        settings: 'সেটিংস',
        logout: 'লগ আউট',
        menu: 'মেনু',
        close: 'বন্ধ',
        cancel: 'বাতিল',
        save: 'সেভ করুন',
        delete: 'মুছে ফেলুন',
        confirmDelete: 'মুছে ফেলা নিশ্চিত করুন',
        deleteAccount: 'অ্যাকাউন্ট মুছে ফেলুন',
        areYouSure: 'আপনি কি নিশ্চিত যে এটি মুছে ফেলতে চান?',
        beforeYouDelete: 'অ্যাকাউন্টটি মুছে ফেলার আগে:',
        accountNoLongerAppear: 'এই অ্যাকাউন্টটি আপনার অ্যাকাউন্ট তালিকায় আর দেখা যাবে না।',
        pastTransactionsUnchanged: 'অতীতের লেনদেনগুলো অপরিবর্তিত থাকবে।',
        accountBalanceMustBeZero: 'মুছে ফেলার আগে অ্যাকাউন্টের ব্যালেন্স শূন্য হতে হবে।',
        edit: 'এডিট',
        submit: 'জমা দিন',
        loading: 'লোড হচ্ছে...',
        error: 'ভুল হয়েছে',
        success: 'সফল হয়েছে',
        warning: 'সতর্কবার্তা',
        info: 'তথ্য',

        // Auth Messages
        userNotAuthorized: 'আপনার অনুমতি নেই',
        somethingWentWrong: 'কিছু ভুল হয়েছে! পরে আবার চেষ্টা করুন।',
        invalidCredentials: 'ভুল ইমেইল বা পাসওয়ার্ড',
        loginFailed: 'লগইন করা যায়নি। আবার চেষ্টা করুন।',
        logoutSuccess: 'সফলভাবে লগ আউট হয়েছে',
        registerSuccess: 'রেজিস্ট্রেশন সফল! এখন লগইন করুন।',
        loginSuccess: 'লগইন সফল হয়েছে!',

        // Profile Page
        myAccount: 'আমার অ্যাকাউন্ট',
        updatePassword: 'পাসওয়ার্ড আপডেট',
        helpCenter: 'হেল্প সেন্টার',
        helpCenterSubtitle: 'Xpenso সম্পর্কিত সাধারণ প্রশ্নের দ্রুত উত্তর',
        searchFaqPlaceholder: 'একটি বিষয় খুঁজুন...',
        noFaqFound: 'কোনো ফলাফল পাওয়া যায়নি',
        noFaqFoundHint: 'ভিন্ন কীওয়ার্ড দিয়ে চেষ্টা করুন অথবা নিচের সব প্রশ্ন দেখুন',
        clearSearch: 'মুছুন',
        faqCount: 'টি প্রশ্ন',
        changePassword: 'পাসওয়ার্ড পরিবর্তন করুন',
        forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
        resetPassword: 'পাসওয়ার্ড রিসেট করুন',
        passwordUpdated: 'পাসওয়ার্ড আপডেট সফল হয়েছে',
        passwordUpdateFailed: 'পাসওয়ার্ড আপডেট করা যায়নি',
        passwordUpdateSubtitle: 'শক্তিশালী ও ইউনিক পাসওয়ার্ড দিয়ে অ্যাকাউন্ট নিরাপদ রাখুন',
        passwordRequirementHint:
            'কমপক্ষে ৬ অক্ষর ব্যবহার করুন। শক্তিশালী পাসওয়ার্ডের জন্য বড় হাতের অক্ষর, সংখ্যা ও চিহ্ন মিশিয়ে দিন।',

        // Authentication
        email: 'ইমেইল অ্যাড্রেস',
        password: 'পাসওয়ার্ড',
        confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
        oldPassword: 'পুরানো পাসওয়ার্ড',
        newPassword: 'নতুন পাসওয়ার্ড',
        currentPassword: 'বর্তমান পাসওয়ার্ড',
        enterEmail: 'আপনার ইমেইল লিখুন',
        enterPassword: 'আপনার পাসওয়ার্ড লিখুন',
        enterNewPassword: 'নতুন পাসওয়ার্ড লিখুন',
        emailId: 'ইমেইল আইডি',
        rememberMe: 'আমাকে মনে রাখুন',
        forgotPin: 'পাসওয়ার্ড ভুলে গেছেন?',
        dontHaveAccount: 'অ্যাকাউন্ট নেই?',
        alreadyHaveAccount: 'ইতিমধ্যে অ্যাকাউন্ট আছে?',
        signIn: 'সাইন-ইন করুন',
        signUp: 'ফ্রি অ্যাকাউন্ট তৈরি করুন',
        signUpSubTitle: 'সহজেই আপনার টাকার হিসাব রাখুন।',
        enterName: 'আপনার নাম লিখুন',
        signupWithEmail: 'তথ্য দিয়ে রেজিস্ট্রেশন করুন',
        continueWithGoogle: 'গুগল দিয়ে এগিয়ে যান',
        continueWithFacebook: 'ফেসবুক দিয়ে এগিয়ে যান',
        createAccount: 'অ্যাকাউন্ট তৈরি করুন',
        passwordsDoNotMatch: 'পাসওয়ার্ডের মিল নেই',
        passwordTooShort: 'পাসওয়ার্ড কমপক্ষে ৬ অক্ষরের হতে হবে',
        invalidEmail: 'সঠিক ইমেইল অ্যাড্রেস লিখুন',
        register: 'রেজিস্ট্রেশন',
        login: 'লগইন',
        or: 'অথবা',

        // Home Page
        totalBalance: 'মোট ব্যালেন্স',
        totalIncome: 'মোট আয়',
        total: 'মোট',
        income: 'আয়',
        expense: 'খরচ',
        recentTransactions: 'সাম্প্রতিক লেনদেন',
        topExpenses: 'শীর্ষ খরচ',
        allWallets: 'সব ওয়ালেট',
        wallets: 'ওয়ালেট',
        noTransactions: 'এখনও কোনো লেনদেন নেই',
        noAccounts: 'এখনও কোনো অ্যাকাউন্ট নেই',
        noCards: 'এখনও কোনো কার্ড নেই',
        noCardAdded: 'কোনো কার্ড নেই।',
        youHaventAdded: 'আপনি এখনও কোনো কার্ড যোগ করেননি!!',
        viewAll: 'সব দেখুন',
        addNew: 'নতুন যোগ করুন',
        addAccount: 'অ্যাকাউন্ট যোগ করুন',
        addCard: 'কার্ড যোগ করুন',
        statistics: 'পরিসংখ্যান',
        expensePerDay: 'দৈনিক খরচ',
        todayExpense: 'আজকের খরচ',
        monthlyAnalytics: 'মাসিক অ্যানালিটিক্স',
        balanceTrend: 'ব্যালেন্সের প্রবণতা',
        categoryWiseExpense: 'ক্যাটাগরি অনুযায়ী খরচ',
        categoryWiseIncome: 'ক্যাটাগরি অনুযায়ী আয়',
        analytics: 'বিশ্লেষণ',
        expenses: 'খরচ',
        notification: 'বিজ্ঞপ্তি',
        muteNotification: 'বিজ্ঞপ্তি মিউট করুন',
        markAsAllRead: 'সব পড়া হয়েছে হিসেবে চিহ্নিত করুন',
        removeAll: 'সব মুছে ফেলুন',
        system: 'সিস্টেম',
        noNewNotification: 'নতুন কোনো বিজ্ঞপ্তি নেই',
        noNotificationFound: 'গত ৩০ দিনে কোনো বিজ্ঞপ্তি পাওয়া যায়নি!',
        addMoney: '+ টাকা যোগ করুন',
        transactionSuccessful: 'লেনদেন সফল হয়েছে!',
        thisMonth: 'এই মাসে',
        seeAll: 'সব দেখুন',
        noExpenses: 'কোনো খরচ নেই',
        noExpenseThisMonth: 'এই মাসে কোনো খরচের হিসাব পাওয়া যায়নি!',
        noExpenseThisYear: 'এই বছরে কোনো খরচের হিসাব পাওয়া যায়নি!',
        latestTransaction: 'সর্বশেষ লেনদেন',
        mostRecent: 'সবচেয়ে সাম্প্রতিক',
        balance: 'ব্যালেন্স',
        accounts: 'অ্যাকাউন্ট',
        account: 'অ্যাকাউন্ট',
        currentBalance: 'বর্তমান ব্যালেন্স',
        showInHome: 'হোম স্ক্রিনে দেখান',
        showInHomeInfo: 'চালু থাকলে এই অ্যাকাউন্টটি আপনার হোম স্ক্রিনে দেখাবে।',
        countTowardsTotal: 'মোট ব্যালেন্সে যোগ করুন',
        countTowardsTotalInfo:
            'FD, SIP বা বিনিয়োগের মতো নন-লিকুইড সম্পদের জন্য বন্ধ করুন। এই ব্যালেন্স হোম পেজের মোট ব্যালেন্সে যোগ হবে না।',
        updateAccount: 'অ্যাকাউন্ট আপডেট করুন',
        enterAccountName: 'অ্যাকাউন্টের নাম লিখুন',
        enterCurrentBalance: 'বর্তমান ব্যালেন্স লিখুন',
        enterAccountNumber: 'অ্যাকাউন্ট নম্বর লিখুন',

        currentAccount: 'চলতি হিসাব (কারেন্ট অ্যাকাউন্ট)',
        savingsAccount: 'সঞ্চয়ী হিসাব (সেভিংস অ্যাকাউন্ট)',
        fixedDeposit: 'স্থায়ী আমানত (এফডিআর)',
        depositPremiumScheme: 'ডিপিএস (ডিপোজিট প্রিমিয়াম স্কিম)',
        cards: 'কার্ড',
        loadingCards: 'কার্ড লোড হচ্ছে',
        cardsSlider: 'কার্ড স্লাইডার',
        cardsAvailable: 'টি কার্ড আছে',
        logOut: 'লগ আউট',
        dark: 'ডার্ক মোড',

        // Transaction
        transactions: 'লেনদেন',
        transactionHistory: 'লেনদেনের ইতিহাস',
        transaction: 'লেনদেন',
        amount: 'টাকার পরিমাণ',
        date: 'তারিখ',
        category: 'ক্যাটাগরি',
        description: 'বিবরণ',
        from: 'প্রেরক (থেকে)',
        to: 'প্রাপক (কে)',
        status: 'স্ট্যাটাস',
        pending: 'অপেক্ষমান',
        completed: 'সম্পন্ন',
        failed: 'ব্যর্থ হয়েছে',
        cancelled: 'বাতিল',
        time: 'সময়',
        noData: 'কোনো তথ্য পাওয়া যায়নি',

        // Categories
        categoryExpense: 'ক্যাটাগরি অনুযায়ী খরচ',
        allCategories: 'সব ক্যাটাগরি',
        food: 'খাবার',
        transport: 'যাতায়াত',
        shopping: 'কেনাকাটা',
        entertainment: 'বিনোদন',
        utilities: 'ইউটিলিটি বিল',
        healthcare: 'চিকিৎসা',
        education: 'শিক্ষা',
        other: 'অন্যান্য',

        // Reports
        reports: 'রিপোর্ট',
        balanceReport: 'ব্যালেন্স রিপোর্ট',
        incomeReport: 'আয়ের রিপোর্ট',
        cashFlow: 'নগদ প্রবাহ',
        monthly: 'মাসিক',
        yearly: 'বার্ষিক',
        reportType: 'রিপোর্ট প্রকার',
        lastMonth: 'গত মাস',
        thisYear: 'এই বছর',
        lastYear: 'গত বছর',
        lending: 'ঋণ/ধার',
        monthlyStatistics: 'মাসিক পরিসংখ্যান',
        yearlyStatistics: 'বার্ষিক পরিসংখ্যান',
        earnings: 'উপার্জন',
        dropped: 'হ্রাস পেয়েছে',
        improved: 'বৃদ্ধি পেয়েছে',
        comparedToPreviousMonth: 'আগের মাসের তুলনায়',
        comparedToLastYear: 'গত বছরের তুলনায়',
        theSameAsLastYear: 'গত বছরের',

        // Settings
        systemLanguage: 'অ্যাপের ভাষা',
        chooseLanguage: 'পছন্দের ভাষা বেছে নিন',
        darkMode: 'ডার্ক মোড',
        notifications: 'নোটিফিকেশন',
        privacyPolicy: 'গোপনীয়তা নীতিমালা',
        termsConditions: 'শর্তাবলী',
        about: 'অ্যাপ সম্পর্কে',
        version: 'ভার্সন',
        accountSettings: 'অ্যাকাউন্ট সেটিংস',
        securitySettings: 'নিরাপত্তা সেটিংস',
        appSettings: 'অ্যাপ সেটিংস',
        pushNotifications: 'পুশ নোটিফিকেশন',
        getNotified: 'গুরুত্বপূর্ণ আপডেট এবং সতর্কতা সম্পর্কে অবহিত থাকুন',
        languageRegion: 'ভাষা ও অঞ্চল',
        securityPrivacy: 'নিরাপত্তা ও গোপনীয়তা',
        updatePasswordRegularly: 'নিরাপত্তার জন্য নিয়মিত পাসওয়ার্ড আপডেট করুন',
        twoFactorAuth: 'টু-ফ্যাক্টর অথেন্টিকেশন',
        extraSecurityLayer: 'অতিরিক্ত নিরাপত্তা স্তর যোগ করুন',
        helpSupport: 'সাহায্য ও সহায়তা',
        findAnswers: 'সাহায্য নিন অথবা সাধারণ জিজ্ঞাসা (FAQ-এর জন্য)।',
        soon: 'শীঘ্রই',
        installApp: 'অ্যাপ ইনস্টল করুন',
        install: 'ইনস্টল',
        viewInstructions: 'কিভাবে ইনস্টল করবেন',
        installAppDescIOS: 'আইফোন/আইপ্যাড: Safari → Share → Add to Home Screen ব্যবহার করুন।',
        installAppDescAndroid:
            'অ্যান্ড্রয়েড: দ্রুত ও ফুল-স্ক্রিন অভিজ্ঞতার জন্য অ্যাপটি ইনস্টল করুন।',
        installAppDescDesktop: 'ডেস্কটপ: দ্রুত অ্যাক্সেসের জন্য কম্পিউটারে অ্যাপটি ইনস্টল করুন।',
        installAppDescSafariDesktop:
            'Safari (Mac): File → Add to Dock ব্যবহার করুন, অথবা Share → Add to Home Screen (যদি থাকে)।',
        installAppNotAvailableDesktop:
            'এখন ইনস্টল অপশনটি পাওয়া যাচ্ছে না। Chrome/Edge এ অ্যাড্রেস বারের Install আইকন বা Menu → Install app ব্যবহার করুন।',
        installAppNotAvailableAndroid:
            "ইনস্টল প্রম্পট এখন পাওয়া যাচ্ছে না। Chrome মেনু (⋮) খুলুন এবং 'Install app' বা 'হোম স্ক্রিনে যোগ করুন' এ ট্যাপ করুন।",

        // Account
        accountName: 'অ্যাকাউন্টের নাম',
        accountNumber: 'অ্যাকাউন্ট নম্বর',
        // accountType: "অ্যাকাউন্টের ধরন",
        accountType: 'ধরন',
        createdDate: 'তৈরি করার তারিখ',
        lastUpdated: 'সর্বশেষ আপডেট',
        myAccounts: 'আমার অ্যাকাউন্ট',
        accountDetails: 'অ্যাকাউন্টের বিস্তারিত',
        accountBalances: 'অ্যাকাউন্ট ব্যালেন্স',
        accountRemarks: 'মন্তব্য',
        enterAccountRemarks: 'এই অ্যাকাউন্ট সম্পর্কে একটি নোট যোগ করুন...',
        accountAttachment: 'অ্যাকাউন্ট ছবি',
        transactionAttachment: 'সংযুক্তি',
        uploadAttachment: 'ফাইল আপলোড করুন',
        changeAttachment: 'ফাইল পরিবর্তন করুন',
        viewAttachment: 'দেখুন',
        imageUnavailable: 'ছবি পাওয়া যায়নি',
        confirmAttachmentDelete: 'এই সংযুক্তিটি মুছে ফেলবেন? এটি আর ফেরত আনা যাবে না।',
        deleteAttachment: 'সংযুক্তি মুছুন',
        attachmentUploaded: 'সংযুক্তি আপলোড হয়েছে!',
        attachmentDeleted: 'সংযুক্তি মুছে ফেলা হয়েছে!',
        uploadingAttachment: 'সংযুক্তি আপলোড হচ্ছে...',
        onlyImageAllowed: 'শুধুমাত্র ছবি ফাইল (JPEG, PNG, WebP) অনুমোদিত।',
        onlyAttachmentTypesAllowed: 'শুধুমাত্র JPEG, PNG, WebP, PDF অথবা TXT ফাইল অনুমোদিত।',
        fileSizeLessThan4MB: 'ফাইলের আকার ৪ MB এর কম হতে হবে।',

        // Cards
        cardNumber: 'কার্ড নম্বর',
        lastFourDigits: 'শেষ ৪ অঙ্ক',
        cardholderName: 'কার্ডধারীর নাম',
        bankName: 'ব্যাংকের নাম',
        expiryDate: 'মেয়াদ',
        cvv: 'CVV',
        cardType: 'কার্ডের ধরন',
        myCards: 'আমার কার্ড',
        addNewCard: 'নতুন কার্ড যোগ করুন',
        cardAdded: 'কার্ড সফলভাবে যোগ করা হয়েছে',
        cardRemoved: 'কার্ড সফলভাবে সরানো হয়েছে',
        cardUpdateSuccessful: 'কার্ড সফলভাবে আপডেট হয়েছে!',
        updateCard: 'কার্ড আপডেট করুন',
        creditCard: 'ক্রেডিট কার্ড',
        debitCard: 'ডেবিট কার্ড',
        cardNetwork: 'কার্ড নেটওয়ার্ক',
        americanExpress: 'আমেরিকান এক্সপ্রেস',
        visa: 'ভিসা',
        mastercard: 'মাস্টারকার্ড',
        expiry: 'মেয়াদ',
        enterLast4Digits: 'শেষ ৪ অঙ্ক দিন',

        // Forms
        name: 'নাম',
        firstName: 'নামের প্রথম অংশ',
        lastName: 'নামের শেষ অংশ',
        phone: 'ফোন নম্বর',
        mobileNumber: 'মোবাইল নম্বর',
        address: 'ঠিকানা',
        city: 'শহর',
        state: 'বিভাগ/জেলা',
        country: 'দেশ',
        zipCode: 'পোস্টাল কোড',
        dateOfBirth: 'জন্ম তারিখ',
        gender: 'লিঙ্গ',
        male: 'পুরুষ',
        female: 'নারী',
        required: 'এই তথ্যটি আবশ্যক',
        pleaseEnter: 'অনুগ্রহ করে লিখুন',
        selectOption: 'একটি অপশন বেছে নিন',

        // Actions
        update: 'আপডেট করুন',
        create: 'তৈরি করুন',
        remove: 'মুছে ফেলুন',
        add: 'যোগ করুন',
        search: 'খুঁজুন',
        filter: 'ফিল্টার',
        sort: 'সাজান',
        refresh: 'রিফ্রেশ করুন',
        download: 'ডাউনলোড',
        export: 'এক্সপোর্ট',
        import: 'ইমপোর্ট',
        upload: 'আপলোড',
        confirm: 'নিশ্চিত করুন',
        verify: 'যাচাই করুন',
        send: 'পাঠান',
        skip: 'এড়িয়ে যান',
        next: 'পরবর্তী',
        previous: 'আগের',
        apply: 'প্রয়োগ করুন',
        selectBothDates: 'অনুগ্রহ করে দুটি তারিখই নির্বাচন করুন।',
        startDateBeforeEndDate: 'শুরুর তারিখ শেষ তারিখের আগে হতে হবে।',

        // Notifications
        noNotifications: 'কোনো নোটিফিকেশন নেই',
        newNotification: 'নতুন নোটিফিকেশন',
        markAsRead: 'পঠিত হিসেবে চিহ্নিত করুন',
        clearAll: 'সব মুছে ফেলুন',

        // Help & Support
        needHelp: 'সাহায্য প্রয়োজন?',
        contactSupport: 'সাপোর্টে যোগাযোগ করুন',
        faq: 'সাধারণ জিজ্ঞাসা (FAQ)',
        documentation: 'ডকুমেন্টেশন',
        reportIssue: 'সমস্যা রিপোর্ট করুন',
        feedbackAndSuggestions: 'মতামত ও পরামর্শ',

        // PWA Installation
        installXpensoToHomeScreen: 'সহজে ব্যবহারের জন্য Xpenso ইনস্টল করুন',
        clickShareIcon: 'শেয়ার আইকনে ক্লিক করুন',
        addToHomeScreen: 'হোম স্ক্রিনে যোগ করুন',
        installInHome: 'হোম স্ক্রিনে ইনস্টল',

        // Validation Messages
        validationError: 'তথ্য সঠিক নয়',
        invalidInput: 'ভুল ইনপুট',
        tryAgain: 'অনুগ্রহ করে আবার চেষ্টা করুন',
        checkNetwork: 'আপনার ইন্টারনেট কানেকশন চেক করুন',
        serverError: 'সার্ভারে সমস্যা হচ্ছে। পরে আবার চেষ্টা করুন।',

        // Success Messages
        savedSuccessfully: 'সফলভাবে সেভ হয়েছে',
        deletedSuccessfully: 'সফলভাবে মুছে ফেলা হয়েছে',
        updatedSuccessfully: 'সফলভাবে আপডেট হয়েছে',
        createdSuccessfully: 'সফলভাবে তৈরি করা হয়েছে',
        operationSuccessful: 'কাজটি সফল হয়েছে',

        // Time
        today: 'আজ',
        yesterday: 'গতকাল',
        week: 'সপ্তাহ',
        month: 'মাস',
        year: 'বছর',
        january: 'জানুয়ারি',
        february: 'ফেব্রুয়ারি',
        march: 'মার্চ',
        april: 'এপ্রিল',
        may: 'মে',
        june: 'জুন',
        july: 'জুলাই',
        august: 'আগস্ট',
        september: 'সেপ্টেম্বর',
        october: 'অক্টোবর',
        november: 'নভেম্বর',
        december: 'ডিসেম্বর',

        // Login
        loginWelcome: 'Xpenso-তে আপনাকে স্বাগতম!',
        loginSubtitle: 'সহজেই আপনার টাকার হিসাব রাখতে লগইন করুন',

        // Forget Password Page
        forgetPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
        forgetPasswordSubtitle: 'চিন্তা করবেন না! আমরা আছি আপনার সাথে।',
        resetPasswordEmail: 'পাসওয়ার্ড রিসেট করতে আপনার রেজিস্টার্ড ইমেইলটি লিখুন।',
        otpVerification: 'আপনার ইমেইলে পাঠানো OTP কোডটি লিখুন।',
        enterOTP: 'OTP কোডটি লিখুন',
        sendOTP: 'OTP পাঠান',
        submitOTP: 'ওটিপি জমা দিন',
        noServerResponse: 'সার্ভার থেকে কোনো সাড়া পাওয়া যায়নি',
        invalidInputData: 'ভুল তথ্য দেওয়া হয়েছে',
        emailNotFound: 'এই ইমেইলটি খুঁজে পাওয়া যায়নি',
        tryAgainLater: 'কিছুক্ষণ পর আবার চেষ্টা করুন',

        // Account Types
        general: 'সাধারণ',
        cash: 'নগদ টাকা',
        current_account: 'চলতি হিসাব (Current)',
        credit_card: 'ক্রেডিট কার্ড',
        savings_account: 'সঞ্চয়ী হিসাব (Savings)',
        fixed_deposit: 'ফিক্সড ডিপোজিট (FDR)',
        dps: 'ডিপিএস (DPS)',
        loan: 'ঋণ / লোন',
        investment: 'বিনিয়োগ',
        others: 'অন্যান্য',

        // New User Settings Page
        newUserSettings: 'নতুন ব্যবহারকারী সেটিংস',
        setupAppPreferences: 'অ্যাপ ব্যবহার শুরু করতে আপনার পছন্দের সেটিংস কনফিগার করুন।',
        selectCurrency: 'মুদ্রা বেছে নিন',
        languageHint: 'অ্যাপের সমস্ত লেখা ও সংখ্যা এই ভাষায় দেখানো হবে।',
        currencyHint: 'আপনার সকল লেনদেনে এই মুদ্রা ব্যবহার করা হবে।',
        currentCashBalance: 'বর্তমান নগদ ব্যালেন্স',
        cashBalanceHint: 'আপনার হাতে বা মানিব্যাগে এখন কত নগদ টাকা আছে?',
        enterCurrentCash: 'বর্তমান ব্যালেন্স লিখুন',
        userNotFound: 'ব্যবহারকারী খুঁজে পাওয়া যায়নি',
        settingsUpdatedSuccessfully: 'সেটিংস আপডেট হয়েছে',

        // Add Transaction Modal
        transferMoney: 'টাকা ট্রান্সফার',
        transfer: 'ট্রান্সফার',
        addExpense: 'খরচ যোগ করুন',
        addIncome: 'আয় যোগ করুন',
        withdrawMoney: 'টাকা উত্তোলন',
        updateExpense: 'খরচ পরিবর্তন',
        updateIncome: 'আয় পরিবর্তন',
        withdraw: 'উত্তোলন',
        addExpenseShort: 'খরচ যোগ করুন',
        addIncomeShort: 'আয় যোগ করুন',
        fromAccount: 'যে অ্যাকাউন্ট থেকে',
        toAccount: 'যে অ্যাকাউন্টে',
        dateTime: 'তারিখ ও সময়',
        remarks: 'মন্তব্য',
        noteOrRemarks: 'নোট বা মন্তব্য',
        payee: 'প্রাপক (কাকে দিচ্ছেন)',
        payeeName: 'প্রাপকের নাম',
        borrowedFrom: 'যার কাছ থেকে নিয়েছেন',
        borrowedFromName: 'তার নাম',
        selectAccount: 'অ্যাকাউন্ট বেছে নিন',
        selectCategory: 'ক্যাটাগরি বেছে নিন',
        outOfWallet: 'ওয়ালেটের বাইরে',
        addTransaction: 'লেনদেন যোগ করুন',
        autoConfirm: 'স্বয়ংক্রিয় নিশ্চিতকরণ',
        enterAmount: 'টাকার পরিমাণ লিখুন',
        deleteTransactionConfirm: 'আপনি কি নিশ্চিত যে এই লেনদেনটি মুছে ফেলতে চান?',
        deleteCardConfirm: 'আপনি কি নিশ্চিত যে এই কার্ডটি মুছতে চান?',
        amountCannotBeEmpty: 'টাকার পরিমাণ খালি বা ০ হতে পারবে না',
        selectToAccount: "অনুগ্রহ করে 'যে অ্যাকাউন্টে' অপশনটি বেছে নিন।",
        accountsCannotBeSame: 'উৎস এবং গন্তব্য অ্যাকাউন্ট একই হতে পারবে না',
        chooseDateAndTime: 'অনুগ্রহ করে তারিখ এবং সময় বেছে নিন।',

        // TransactionHistory Page
        selectPeriod: 'সময়কাল বেছে নিন',
        fromDate: 'শুরু',
        toDate: 'শেষ',
        noTransaction: 'কোনো লেনদেন নেই',
        noTransactionsFound: 'কোনো লেনদেন পাওয়া যায়নি!',
        searchHere: 'এখানে খুঁজুন...',
        lastSixMonth: 'গত ৬ মাস',
        custom: 'কাস্টম',
        allTypes: 'সব ধরন',
        noMoreTransactions: 'আর কোনো লেনদেন নেই',
        resetFilters: 'ফিল্টার রিসেট',

        // MyAccount Page
        currency: 'মুদ্রা',
        taka: 'টাকা (BDT/৳)',
        dollar: 'ডলার (USD/$)',
        onlyJPGPNGWebp: 'শুধুমাত্র JPG, PNG এবং WEBP ফাইল অনুমোদিত।',
        fileSizeShouldBeLess2MB: 'ফাইলের আকার ২MB এর কম হওয়া উচিত।',
        imageTooSmall: 'ছবিটি খুব ছোট। ন্যূনতম আকার ১০০x১০০px।',
        invalidImageFile: 'অবৈধ ছবি ফাইল।',
        userInfoUpdated: 'ব্যবহারকারীর তথ্য আপডেট হয়েছে!',

        // PasswordUpdate Page
        oldPasswordRequired: 'পুরানো পাসওয়ার্ড দিন',
        newPasswordRequired: 'নতুন পাসওয়ার্ড দিন',
        confirmPasswordRequired: 'পাসওয়ার্ডটি নিশ্চিত করুন',
        newPasswordMustBeDifferent: 'নতুন পাসওয়ার্ডটি অবশ্যই আলাদা হতে হবে',
        passwordsMatch: 'পাসওয়ার্ড মিলেছে',
        showPassword: 'পাসওয়ার্ড দেখান',
        hidePassword: 'পাসওয়ার্ড লুকান',
        updating: 'আপডেট হচ্ছে...',
        weak: 'দুর্বল',
        medium: 'মাঝারি',
        strong: 'শক্তিশালী',
        invalidOldPassword: 'পুরানো পাসওয়ার্ডটি সঠিক নয়',

        // HelpCenter Page
        whatIssuesAreFacing: 'আপনি কী ধরনের সমস্যার সম্মুখীন হচ্ছেন?',
        faq1Title: '১. Xpenso কী?',
        faq1Body:
            'Xpenso আপনার ব্যক্তিগত আর্থিক ব্যবস্থাপক। এটি আপনাকে দৈনিক খরচ, আয়, ট্রান্সফার এবং মাসিক রিপোর্ট—সবকিছু এক জায়গায় ট্র্যাক করতে সাহায্য করে।',
        faq2Title: '২. আমি কীভাবে নতুন অ্যাকাউন্ট যোগ করব?',
        faq2Body:
            '"অ্যাকাউন্ট যোগ করুন" বাটনে ট্যাপ করুন, অ্যাকাউন্টের নাম লিখুন (যেমন: নগদ, ব্যাংক বা বিকাশ), ব্যালেন্স সেট করুন এবং সেভ করুন।',
        faq3Title: '৩. আমি কীভাবে খরচের হিসাব রাখব?',
        faq3Body:
            '"খরচ" অপশনে ট্যাপ করুন, একটি অ্যাকাউন্ট সিলেক্ট করুন, টাকার পরিমাণ ও ক্যাটাগরি বসিয়ে সেভ করুন।',
        faq4Title: '৪. আমি কীভাবে আয় যোগ করব?',
        faq4Body:
            '"আয়" অপশনে ট্যাপ করুন, বিবরণ লিখুন এবং যে অ্যাকাউন্টে টাকা জমা হয়েছে সেটি সিলেক্ট করুন।',
        faq5Title: '৫. আমি কি এক অ্যাকাউন্ট থেকে অন্য অ্যাকাউন্টে টাকা স্থানান্তর করতে পারি?',
        faq5Body:
            "হ্যাঁ! 'ট্রান্সফার' অপশন ব্যবহার করে আপনি খুব সহজেই এক অ্যাকাউন্ট থেকে অন্য অ্যাকাউন্টে টাকা পাঠাতে পারেন (যেমন: ব্যাংক থেকে বিকাশ)।",
        faq6Title: "৬. 'শীর্ষ খরচ' (Top Expenses) কী?",
        faq6Body:
            'শীর্ষ খরচ আপনাকে দেখায় এই মাসে কোন খাতে (যেমন: খাবার বা মুদি বাজার) আপনার সবচেয়ে বেশি টাকা খরচ হয়েছে।',
        faq7Title: '৭. মাসিক পরিসংখ্যান কী?',
        faq7Body:
            'এটি আপনার আয় ও খরচের হিসাবকে আগের মাসের সাথে তুলনা করে দেখায়, যা আপনাকে বাজেট নিয়ন্ত্রণে সাহায্য করে।',
        faq8Title: '৮. আমার ডেটা কি নিরাপদ?',
        faq8Body:
            'হ্যাঁ। আপনার সকল ডেটা এনক্রিপ্টেড অবস্থায় সংরক্ষিত থাকে এবং শুধুমাত্র আপনিই তা দেখতে পারেন। Xpenso কখনোই আপনার ব্যক্তিগত তথ্য বা ডেটা অন্য কারো সাথে শেয়ার করে না।',
        faq9Title: '৯. আমি কি কোনো লেনদেন পরিবর্তন বা মুছে ফেলতে পারি?',
        faq9Body:
            'অবশ্যই! যেকোনো লেনদেনের ওপর ট্যাপ করে আপনি সেটি এডিট (সম্পাদনা) করতে পারেন অথবা প্রয়োজন হলে ডিলিট (মুছে ফেলা) করতে পারেন।',

        // Voice Command
        voiceListening: 'শুনছি...',
        voiceProcessing: 'প্রক্রিয়া করা হচ্ছে...',
        voiceTapToSpeak: 'কমান্ড বলুন...',
        voiceStopListening: 'শোনা বন্ধ করুন',
        voiceMissingAmount: "পরিমাণ বুঝতে পারিনি। চেষ্টা করুন: 'খরচ ২০০ খাবার'",
        voiceMissingCategory: 'ক্যাটাগরি মেলানো যায়নি',
        voiceMissingType: "পরিমাণের আগে 'খরচ' বা 'আয়' বলুন",
        voiceNoAccount: 'কোনো অ্যাকাউন্ট পাওয়া যায়নি। প্রথমে একটি অ্যাকাউন্ট যোগ করুন।',
        voiceTryAgain: 'বুঝতে পারিনি। আবার চেষ্টা করুন।',
        voiceNoSpeech: 'কোনো কথা শোনা যায়নি। ট্যাপ করে স্পষ্টভাবে বলুন।',
        voiceMicPermission: 'মাইক্রোফোনের অনুমতি দেওয়া হয়নি। অনুমতি দিন।',
        voiceNetworkError: 'স্পিচ সার্ভিস ব্লক হয়েছে। ব্রাউজারের প্রাইভেসি সেটিংস দেখুন।',
        voiceNotSupported: 'এই ব্রাউজারে ভয়েস কমান্ড সমর্থিত নয়।',
        voiceConfirmCategory: 'কোন ক্যাটাগরি বুঝেছেন?',
        voiceConfirmAccount: 'কোন অ্যাকাউন্ট?',

        viewTransaction: 'লেনদেন দেখুন',
        topCategory: 'সর্বোচ্চ খরচের ক্যাটাগরি',
        topCategoryExpenseAmount: 'শীর্ষ খাতের খরচ',
    },
};

export const getTranslation = (key, language = 'en') => {
    return translations[language]?.[key] || translations['en'][key] || key;
};
